import React from 'lib/react';
import { EVGrid, EVSkeleton } from 'lib/components';
import ConsumptionPageStyles from './ConsumptionPageStyles';

function ConsumptionPageLoader() {
  const classes = ConsumptionPageStyles();

  return (
    <EVGrid className={classes.contentSection}>
      <EVSkeleton
        style={{
          height: '24px', width: '200px', marginBottom: '24px', borderRadius: '4px',
        }}
        animation="wave"
        variant="rect"
      />
      <EVGrid className={classes.usageSummaryContainer}>
        <EVGrid className={classes.chartSection}>
          <EVSkeleton
            style={{
              height: '320px', width: '100%', borderRadius: '4px',
            }}
            animation="wave"
            variant="rect"
          />
        </EVGrid>
        <EVGrid className={classes.usageTableSection}>
          <EVSkeleton
            style={{
              height: '24px', width: '150px', marginBottom: '16px', borderRadius: '4px',
            }}
            animation="wave"
            variant="rect"
          />
          <EVGrid
            style={{
              display: 'flex', flexDirection: 'column', gap: '12px',
            }}
          >
            {[1, 2, 3, 4].map((i) => (
              <EVSkeleton
                key={i}
                style={{
                  height: '48px', width: '100%', borderRadius: '4px',
                }}
                animation="wave"
                variant="rect"
              />
            ))}
          </EVGrid>
        </EVGrid>
      </EVGrid>
    </EVGrid>
  );
}

export default ConsumptionPageLoader;
